import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  padding: 20px;
  width: 100%;
`;

export const Box = styled.div`
  padding: 25px;
  width: 100%;
  align-items: center;
  margin-top: 30px;
`;
